<template>
  <div class="modal-container">
    <div class="blur-backdrop" @click="close" />
    <div class="modal">
      <div class="title">
        Create a New Prompt Pack
      </div>
      <div class="explanatory-text">
        Name your new prompt pack
      </div>
      <div class="char-limit-row">
        Max {{ packNameCharLimit }} characters
      </div>
      <input
        ref="packNameInput"
        class="create-pack-text"
        type="text"
        v-model="newPromptPackName"
        placeholder="Type in a name for your new prompt pack..."
        @input="clipInputString"
        :maxlength="packNameCharLimit"
        @keydown.enter.prevent="createPromptPack"
      />
      <SpinnerButton
        class="button"
        :isDisabled="!newPromptPackName"
        :isProcessing="isCreatingPromptPack"
        @click="createPromptPack"
      >
        Create Prompt Pack
      </SpinnerButton>
      <SpinnerButton
        class="button danger"
        :isProcessing="isCreatingPromptPack"
        :showSpinner="false"
        @click="close"
      >
        Cancel
      </SpinnerButton>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import SpinnerButton from '@/components/utilComponents/SpinnerButton.vue';

export default Vue.extend({
  name: 'CreatePackModal',
  components: {
    SpinnerButton
  },
  data: () => ({
    isCreatingPromptPack: false,
    newPromptPackName: '',
    packNameCharLimit: 24
  }),
  computed: {
    auth0UserId: function () {
      return this.$auth.user.sub.replace(/\|/g, '_');
    },
    idToken: function () {
      return this.$auth.idToken;
    }
  },
  methods: {
    clipInputString() {
      if (this.maxLength && this.value.length > this.maxLength) {
        this.value = this.value.slice(0, this.maxLength);
      }
    },
    async createPromptPack() {
      if (!this.newPromptPackName || this.isCreatingPromptPack) {
        return;
      }
      this.isCreatingPromptPack = true;
      await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/createpromptpack`, {
        auth0UserId: this.auth0UserId,
        promptPackName: this.newPromptPackName
      }, {
        headers: {
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${this.idToken}`
        }
      });
      this.isCreatingPromptPack = false;
      this.$emit('prompt-pack-created');
      this.close();
    },
    close() {
      if (this.isCreatingPromptPack) {
        return;
      }
      this.$emit('close');
    }
  },
  mounted: function () {
    this.$refs.packNameInput.focus();
  }
})
</script>

<style scoped lang="scss">
@import '@/styles/modal-styles.scss';
</style>
